import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=2b11ec6b&"
import script from "./DialogComponent.vue?vue&type=script&lang=ts&"
export * from "./DialogComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports